import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { ArchiveFinderModel, Fields } from '../../models/archive-finder.model';
import { EmailFilterTracker } from '../../models/email-filter-tracker';
import * as Moment from 'moment';
import { ArchiveFinderTimelineModel } from '../../models/archive-finder-timeline.model';
import { TrackerSearch } from '../../../shared/tracker-search/tracker-search';
import { BaseService } from '../BaseService';
import { consoleLogDevEnv } from '../../../../core/_helpers/util';

@Injectable({
  providedIn: 'root',
})
export class TrackerService extends BaseService {

  protected urlPath = '/v1/archive-finder';

  constructor(
    protected _http: HttpClient,
    protected _trackerSearch: TrackerSearch,
  ) {
    super(_http);
  }

  public getOneResult(id: number): Observable<Fields> {
    return this._http
      .get<Fields[]>(this.getFullUrl(id.toString()))
      .pipe(map((res: any) => res.fields));
  }

  public getResult(
    filter: EmailFilterTracker = null,
    search: string = '',
  ): Observable<ArchiveFinderModel> {
    const filterString: string = this._filterToSearchString(filter);

    if (filterString) {
      const params = new HttpParams({
        fromObject: {
          filter: filterString,
          search_all:
            search && search.length ? search.trim().toLowerCase() : '',
          page: filter.page.toString(),
        },
      });
      consoleLogDevEnv('filterString', { params });
      return this._http.get<ArchiveFinderModel>(this.urlPath, { params });
    } else {
      consoleLogDevEnv('!filterString');
      return this._http.get<ArchiveFinderModel>(this.urlPath);
    }
  }

  public getFlags(): Observable<any> {
    return this._http
      .get<any[]>(this.getFullUrl('form/flags'))
      .pipe(map((res: any) => res.rows));
  }

  public getTimeLine(id: string): Observable<ArchiveFinderTimelineModel> {
    return this._http.get<ArchiveFinderTimelineModel>(this.getFullUrl(`timeline/${id}`));
  }

  public getRules(): Observable<any> {
    return this._http
      .get<any[]>(this.getFullUrl('form/rules'))
      .pipe(map((res: any) => res.rows));
  }

  public getMTA(): Observable<any> {
    return this._http
      .get<any[]>(this.getFullUrl('form/mta'))
      .pipe(map((res: any) => res.rows));
  }

  protected _filterToSearchString(filter: EmailFilterTracker = null): string {
    if (filter) {
      this._trackerSearch.reset(filter);

      this._trackerSearch.validateFilter('maxPerPage');
      this._trackerSearch.validateFilter('sender');
      this._trackerSearch.validateFilter('subject');
      this._trackerSearch.validateFilter('recipients');
      this._trackerSearch.validateFilter('flags');
      this._trackerSearch.validateFilter('status');
      this._trackerSearch.validateFilter('RELEASED_AT');
      this._trackerSearch.validateFilter('orderBy');
      this._trackerSearch.validateFilter('emailAddress');
      this._trackerSearch.validateFilter('senderMTA');
      this._trackerSearch.validateFilter('senderHeader');

      if (filter.startDate) {
        this._trackerSearch.addParam('startDate', Moment(filter.startDate).format(), true);
      }

      if (filter.endDate) {
        this._trackerSearch.addParam('endDate', Moment(filter.endDate).format(), true);
      }
    }

    return this._trackerSearch.getParam();
  }
}
